export const DEFAULT_DIALOGUE_SPEED = 1.4;
export const DEFAULT_SILENCE_SPEED = 3.5;

export const DEFAULT_SYNC_INTERVAL = 30; // seconds

export const LOOKBEHIND_BUFFER_MILLIS = 50;
export const LOOKAHEAD_BUFFER_MILLIS = 0;
